export default __webpack_public_path__ + "static/media/arrowRight.f9374dc2.svg";